module.exports = __webpack_public_path__ + "static/media/post.3fb28d1d.jpg";